export default {
  setBannerList(state, bannerList) {
    state.bannerList = bannerList;
  },
  setPopupList(state, popupList) {
    state.popupList = popupList;
  }
};
